import { render, staticRenderFns } from "./publicexamLayout.vue?vue&type=template&id=60c680dc&scoped=true"
import script from "./publicexamLayout.vue?vue&type=script&lang=js"
export * from "./publicexamLayout.vue?vue&type=script&lang=js"
import style0 from "./publicexamLayout.vue?vue&type=style&index=0&id=60c680dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c680dc",
  null
  
)

export default component.exports